import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Quote from '@/pages/Quote'
import Login from '@/pages/Login'
import Download from '@/pages/Download'
import PasswordRecovery from '@/pages/PasswordRecovery'
import RequestAccess from '@/pages/RequestAccess'
import ComponentLoader from '@/router/ComponentLoader'
import cookies from 'vue-js-cookie'
import Store from '@/store'
import i18n from '@/languages';
import AppHelper from "../helper";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    saveScrollPosition: true,
    routes: [
        {
            path: '/dashboard',
            name: 'Dashboard',
            beforeEnter: (to, from, next) => {
                next({
                    name: 'Index',
                    params: {module: Store.getters.getStructure.access.client_portal ? 'HelpDesk' : 'GDPR', view: 'Index'}
                })
            },
        },
        {
            path: '/quote/:token',
            name: 'Quote',
            meta: {
                title: i18n.t('LBL_QUOTE_TITLE'),
                standaloneTitle: true
            },
            component: Quote,
            props: true
        },
        {
            path: '/:module/:view',
            name: 'Index',
            component: ComponentLoader,
            props: true
        },
        {
            path: '/download/:key/:file',
            name: 'Download',
            meta: {
                title: i18n.t('LBL_DOWNLOAD_PAGE')
            },
            component: Download,
        },
        {
            path: '/:module/:view/:record',
            name: 'Detail',
            component: ComponentLoader,
            props: true
        },
        {
            path: '/home/:key',
            name: 'Home',
            meta: {
                title: i18n.t('LBL_HOME_PAGE')
            },
            component: Home,
        },
        {
            path: '/login',
            name:  'Login',
            meta: {
                title: i18n.t('LBL_LOGIN_PAGE'),
                fetchInstanceKey: true
            },
            component:  Login,
        },
        {
            path: '/passwordrecovery',
            name: 'PasswordRecovery',
            meta: {
                title: i18n.t('LBL_PASSWORD_RECOVERY_PAGE')
            },
            component: PasswordRecovery
        },
        {
            path: '/requestaccess',
            name: 'RequestAccess',
            meta: {
                title: i18n.t('LBL_REQUEST_ACCESS_PAGE')
            },
            component: RequestAccess
        },
        {
            path: '/:key',
            redirect: {name: 'Home'},
        },
        {
            path: '*',
            redirect: {name: 'Dashboard'}
        }
    ],
})


router.beforeEach(async (to, from, next) => {
    var titles = to.meta.standaloneTitle ? [] : [i18n.t('LBL_GDPR_PORTAL')]

    if(!AppHelper.empty(to.meta.title)){
        titles.push(to.meta.title)
    }

    document.title = titles.join(' - ')

    if(!AppHelper.empty(to.params.key)) {
        cookies.set('instance', to.params.key, 365)
    }

    if (to.meta.fetchInstanceKey || AppHelper.empty(cookies.get('instance'))) {
        var response = await Api.getInstanceKey(window.location.origin)
        if(response.result){
            cookies.set('instance', response.result, 365)
        }
    }

    if($.inArray(to.name, ['Login', 'PasswordRecovery', 'RequestAccess', 'Quote'])  > -1){
        next()
        return
    }
    else if(!Api.isAuthenticated()){
        if(to.name == 'Download'){
            Store.commit('setRedirect', to)
        }
        next({name: 'Login'})
        return
    }

    if(AppHelper.empty(Store.state.structure)){
        await Store.dispatch('fetchStructure')
    }

    next()
})

export default router;
